/* eslint-disable no-unused-vars */
import { Button, MenuItem, Select } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import REACT_APP from "../../environment";
import axios from "axios";
import React from "react";

const WorkSpace = ({ bgdDisable, setbgdDisable }) => {
    const [loading, setLoading] = React.useState(false);
    const handleChange = (e) => setbgdDisable(e.target.value === true || e.target.value === "true");

    const save = () => {
        setLoading(true)
        axios
            .put(`${REACT_APP.URL}/api/hrp/tts/adm/policy/bgd`, { disabled: bgdDisable }, {
                headers: { Authorization: sessionStorage.getItem("token"), "client-id": REACT_APP.CLIENTID, "client-secret": REACT_APP.SECRET },
            })
            .catch((err) => {
                console.log(err);
            });
        setLoading(false)
    };

    return (
        <div>
            <h2 style={{ margin: "20px" }}>Integration with BDG</h2>
            <div style={{ display: "flex", gap: "20px", margin: "20px" }}>
                <Select value={bgdDisable} onChange={handleChange} size="small" style={{ width: "200px" }} disabled={loading}>
                    <MenuItem value="false">Enabled</MenuItem>
                    <MenuItem value="true">Disabled</MenuItem>
                </Select>
                {loading ? (
                    <LoadingButton loading variant="contained" color="success">
                        save
                    </LoadingButton>
                ) : (
                    <Button type="button" variant="contained" color="success" onClick={save}>
                        save
                    </Button>
                )}
            </div>
        </div>
    );
};

export default WorkSpace;
